// extracted by mini-css-extract-plugin
export default {"offer":"offer_offer__uV+n7","background":"offer_background__aaOWx","description":"offer_description__bxEhX","box":"offer_box__r2Vas","right":"offer_right__pWM-l"};